import { Container, Typography } from '@mui/material'
import { Box } from '@mui/system'
import Rocket from './rocket.png'

export default function LowerAbout() {
  return (
    <>
      <Box>
        <Container>
          <Box
            style={{
              padding: '400px 0',
              // paddingBottom: '100px',
              backgroundImage: `url(${Rocket})`,
              backgroundPosition: 'right center',
              backgroundSize: 'auto',
              backgroundRepeat: 'no-repeat',
              marginTop: '-300px',
            }}
          >
            <Typography
              fontSize={{ xs: '20px' }}
              sx={{
                color: 'white',
                textAlign: 'justify',
                letterSpacing: '27%',
                margin: '150px auto 0px auto',
              }}
              width={{ xs: '80%', md: '60%' }}
            >
              Solar is the first U.S Based Solana Dex that offers a one of a
              kind safe platform. Solar eliminates the need for third-party
              liquidity locks by making it mandatory for every liquidity pool to
              lock for 3 months. This means NO MORE RUG PULLS!
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  )
}
